// 庖丁账号角色枚举（与后端 AdminRole 枚举一一对应）
// 后端注释：0 普通用户 1 管理员 2 超级管理员 3 特殊用户(内容审核) -1 停用账户(注销, 软删除)
export const roleMap: Record<number, string> = {
    [-1]: '停用账户(注销，软删除)',
    0: '普通用户',
    1: '管理员（普通管理员）',
    2: '超级管理员',
    3: '特殊用户(内容审核)'
}

// 创建/编辑账号时使用的下拉选项，顺序与后端枚举定义保持一致
export const roleOptions: Array<{ value: number; name: string }> = [
    { value: -1, name: roleMap[-1] },
    { value: 0, name: roleMap[0] },
    { value: 1, name: roleMap[1] },
    { value: 2, name: roleMap[2] },
    { value: 3, name: roleMap[3] }
]
